<template>
  <div class="flex flex-col items-center text-center pb-4">
    <h5 class="text-lg font-semibold mb-4">Terms & Conditions</h5>
  </div>

  <div class="text-sm text-gray-800 px-4 pb-8 max-h-[400px] overflow-y-auto text-left">
    <!-- Render HTML with enforced list styling -->
    <div
      v-if="isHtmlContent"
      v-html="cleanedTnC"
      class="prose prose-sm list-disc list-inside [&_ul]:list-disc [&_ul]:pl-5 [&_li]:mb-1"
    ></div>

    <!-- Fallback for plain text -->
    <ol v-else class="list-decimal space-y-2 pl-5">
      <li v-for="(item, index) in parsedTerms" :key="index">
        {{ item }}
      </li>
    </ol>
  </div>
</template>

<script setup>
const props = defineProps(['data'])
const rawTnC = props.data?.value?.tAndC || ''

const isHtmlContent = computed(() =>
  /<br\s*\/?>|<ul>|<li>|<\/p>/i.test(rawTnC)
)

const cleanedTnC = computed(() =>
  rawTnC
    .replace(/\\r\\n/g, '\n')
    .replace(/\r\n/g, '\n')
    .replace(/\\n/g, '<br/>')
)

const parsedTerms = computed(() => {
  if (!rawTnC || isHtmlContent.value) return []

  const cleaned = rawTnC
    .replace(/\\r\\n/g, '\n')
    .replace(/\r\n/g, '\n')
    .replace(/"/g, '')
    .replace(/\\n/g, '\n')

  const terms = cleaned.split(/\d+\.\s/).filter(t => t.trim().length)
  return terms.map(t => t.trim())
})
</script>
